import { defaultMessageBackend, noValidation } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/placements--jira-empanada/issue-navigator-placement';

import { ListMergeSpotlightTour } from '../../../components/ListMergeSpotlightTour';

export type MessageTemplateContext = {
	message: string;
};

type RenderProps = MessageTemplateContext & PlacementRenderProps;

export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),
		Component: () => <ListMergeSpotlightTour />,
	},
});
